// extracted by mini-css-extract-plugin
export default {"container":"styles_container__lgIH-","detailContainer":"styles_detailContainer__OIQDb","text":"styles_text__VA7QB","button":"styles_button__IUrWH"};